<script setup lang="ts">
import { defineEmits, ref } from 'vue';
import { RefreshIcon } from '@heroicons/vue/outline';
import { Brand } from '../../services/integration/enums';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const loading = ref(false);

const emit = defineEmits<{(e: 'onClick', done: () => void): void}>();

const finishOnClick = () => {
  loading.value = false;
};

const onClick = async () => {
  // Don't run handler if the button is already handling something.
  if (loading.value) {
    return;
  }

  loading.value = true;
  await emit('onClick', finishOnClick);
};
</script>

<template>
  <button @click="onClick" type="submit" :class="brandService.getName() === Brand.HIS ? 'font-gotham-bold shadow-sm transition duration-250 w-full lg:w-auto flex items-center justify-center px-6 py-4 text-base md:text-md rounded-lg text-brand-button-text bg-brand-button hover:bg-brand-button-hover md:text-lg md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent': 'transition duration-250 rounded-full hover:bg-white hover:border-solid hover:border-black bg-transparent bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark py-3 px-6 shadow-md text-center font-poppins text-black border-none text-lg w-auto cursor-pointer'" class="">
    <slot></slot>
    <div class="pl-4 flex align-middle" v-if="loading">
      <div class="h-6 inline-block w-6 animate-spin">
        <RefreshIcon></RefreshIcon>
      </div>
    </div>
  </button>
</template>
